jQuery(() => {
    const markerIcon = window.themeBasePath + 'assets/images/marker.png';

    function addMarker($markerSrc, map, index) {
        // var
        const $marker = jQuery($markerSrc);
        const latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
        const image = new google.maps.MarkerImage(
            markerIcon, null, null, null, new google.maps.Size(38, 51),
        );

        // create marker
        const marker = new google.maps.Marker({
            position: latlng,
            map,
            icon: image,
        });

        // add to array
        map.markers.push(marker);


        // if marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
            $('#listdata').append('<div class= "linkage" id="p' + index + '">' + $marker.html() + '</div>'); // change html here if you want but eave id intact!!

            // create info window
            const infowindow = new google.maps.InfoWindow({
                content: $marker.html(),
            });

            $(document).on('click', '#p' + index, () => {
                infowindow.open(map, marker);
                setTimeout(() => { infowindow.close(); }, 5000);
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', () => {
                infowindow.open(map, marker);
            });
        }
    }

    function centerMap(map) {
        // vars
        const bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        jQuery.each(map.markers, (i, marker) => {
            const latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            bounds.extend(latlng);
        });

        map.setCenter(bounds.getCenter());
        map.setZoom(12);
    }

    function newMap($el) {
        // var
        const $markers = jQuery('.marker');

        // vars
        const args = {
            zoom: 15,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{
                featureType: 'all',
                elementType: 'labels.text.fill',
                stylers: [{
                    saturation: 36,
                }, {
                    color: '#000000',
                }, {
                    lightness: 40,
                }],
            }, {
                featureType: 'all',
                elementType: 'labels.text.stroke',
                stylers: [{
                    visibility: 'on',
                }, {
                    color: '#000000',
                }, {
                    lightness: 10,
                }],
            }, {
                featureType: 'all',
                elementType: 'labels.icon',
                stylers: [{
                    visibility: 'off',
                }],
            }, {
                featureType: 'administrative',
                elementType: 'geometry.fill',
                stylers: [{
                    color: '#212121',
                }, {
                    lightness: 0,
                }],
            }, {
                featureType: 'administrative',
                elementType: 'geometry.stroke',
                stylers: [{
                    color: '#212121',
                }, {
                    lightness: 0,
                }, {
                    weight: 1.2,
                }],
            }, {
                featureType: 'landscape',
                elementType: 'geometry',
                stylers: [{
                    color: '#212121',
                }, {
                    lightness: 0,
                }],
            }, {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [{
                    lightness: 0,
                }, {
                    color: '#212121',
                }],
            }, {
                featureType: 'road.highway',
                elementType: 'geometry.fill',
                stylers: [{
                    color: '#1c1c1c',
                }, {
                    lightness: 0,
                }],
            }, {
                featureType: 'road.highway',
                elementType: 'geometry.stroke',
                stylers: [{
                    color: '#1a1a1a',
                }, {
                    lightness: 0,
                }, {
                    weight: 0.2,
                }],
            }, {
                featureType: 'road.arterial',
                elementType: 'geometry',
                stylers: [{
                    color: '#1a1a1a',
                }, {
                    lightness: 0,
                }],
            }, {
                featureType: 'road.local',
                elementType: 'geometry',
                stylers: [{
                    color: '#1a1a1a',
                }, {
                    lightness: 0,
                }],
            }, {
                featureType: 'transit',
                elementType: 'geometry',
                stylers: [{
                    color: '#1a1a1a',
                }, {
                    lightness: 0,
                }],
            }, {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [{
                    color: '#2e2e2e',
                }, {
                    lightness: 0,
                }],
            }],
        };

        // create map
        const map = new google.maps.Map($el[0], args);

        // add a markers reference
        map.markers = [];

        // add markers
        addMarker($markers[0], map);
        $markers.each(function () {
            addMarker(jQuery(this), map);
        });

        // center map
        centerMap(map);

        // return
        return map;
    }

    jQuery('.acf-map').each(function () {
        map = newMap(jQuery(this));
    });
});
